module.exports = __webpack_public_path__ + "img/i_setting.78dd639a.svg";